<section class="account-layout topbar-padding-top container section-outset-y" *ngIf="customer$() as customer">
  <div class="row">
    <aside class="col-12 col-md-4 col-lg-3">
      <ul class="account-layout__nav">
        <li *ngFor="let item of navItems">
          <a
            class="button button-link button--secondary account-nav-item"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="item.routerLink"
            routerLinkActive="is--active"
          >
            <app-icon [anchor]="item.icon"></app-icon>
            <span>{{ item.title }}</span>
          </a>
        </li>
        <li>
          <button (click)="signOut()" type="button" class="button button-link button--secondary">
            <app-icon anchor="icon-log-out"></app-icon>
            <span>{{ 'account-uitloggen-menu-titel' | fromDictionary }}</span>
          </button>
        </li>
      </ul>
    </aside>
    <main class="col-12 col-md-8 col-lg-9">
      <router-outlet></router-outlet>
    </main>
  </div>
</section>
